<div class="offer-banner" [ngClass]="theme" placement="top" [ngbTooltip]="tooltipText" [container]="'body'">
  <rx-icon class="offer-banner__badge" [centerIcon]="true" [name]="icon" size="md" [fill]="iconColor || 'white'" />
  <span class="offer-banner__message">{{ text }}</span>
</div>
